import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';
import "../../styles/Dashboard.css";
import Home from "./Home/Home";

// Pages
import Reports from "./Reports/Reports";

// import profile pages
import AccountSettings from "./AccountSettings/AccountSettings";

// Logout
import Logout from "./Logout/Logout";


// Context
import UserBasicInfoContext from "../../components/Context/UserBasicInfoContext";
import UserBasicInfoQRContext from "../../components/Context/UserBasicInfoQRContext";

// Context Provider
import IncompleteProfileStepsContextProvider from "../../components/ContextProvider/IncompleteProfileStepsContextProvider";


// Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Store
import StoreCreateCategory from "./Store/Category/StoreCreateCategory";
import StoreEditCategory from "./Store/Category/StoreEditCategory";
import StoreEditDiscount from "./Store/Discount/StoreEditDiscount";
import StoreItemAdd from "./Store/Items/StoreItemAdd";
import StoreItemsDetails from "./Store/Items/StoreItemsDetails";
import Store from "./Store/Store";

// Voucher
import Voucher from "./Voucher/Voucher";


// Root Context
import RootContext from "../../components/Context/RootContext";


// Instant Transfer
import OrderInvoice from "./Orders/OrderInvoice";
import Orders from "./Orders/Orders";
import StoreEditItem from "./Store/Items/StoreEditItem";
import AssignItemImage from "./Store/Items/AssignItemImage";


import PostLoginGetApi from "../../components/Api/PostLoginGetApi";
import AccessDenied from "./AccessDenied/AccessDenied";

// Category
import Category from "./Category/Category";
// import BusinessCategoryList from "./Category/BusinessCategory/CategoryList";
import CreateBusinessCategory from "./Category/BusinessCategory/CreateBusinessCategory";
import UpdateBusinessCategory from "./Category/BusinessCategory/UpdateBusinessCategory";

import CreateCompany from "./Company/CreateCompany";
import UpdateCompany from "./Company/UpdateCompany";
import PermissionList from "./Permission/PermissionList";
import EditAccess from "./Role/Access/EditAccess";
import ViewAccess from "./Role/Access/ViewAccess";
import AddRole from "./Role/AddRole";
import EditRole from "./Role/EditRole";
import RoleList from "./Role/RoleList";
import StoreCreateDiscount from "./Store/Discount/StoreCreateDiscount";
import UserCreation from "./User/UserCreation";
import UserList from "./User/UserList";

import Company from "./Company/Company";
import CompanyDetails from "./Company/CompanyDetails/CompanyDetails";
import SelectCompany from "./SelectCompany/SelectCompany";
import UploadInvoice from "./Store/PickupPoint/UploadPickupPoint";
import UpdateUser from "./User/UpdateUser";
import CreateBrand from "./Voucher/Brand/CreateBrand";
import EditBrand from "./Voucher/Brand/EditBrand";
import CreateVoucherCategory from "./Category/VoucherCategory/CreateVoucherCategory";
import EditVoucherCategory from "./Category/VoucherCategory/EditVoucherCategory";
import CreateOffer from "./Voucher/Offer/CreateOffer";
import EditOffer from "./Voucher/Offer/EditOffer";
import UpdateQuantity from "./Store/Items/UpdateQuantity";
import Settlement from "./Settlement/Settlement";
import BankBranch from "./BankAndBranch/BankBranch";
import ActiveCompanyFromRequest from "./Company/ActiveCompanyFromRequest";
import CreateMou from "./Category/UnitOfMeasure/CreateMou";
import EditMou from "./Category/UnitOfMeasure/EditMou";
import SortVoucherBrandBasedOnCategory from "./Category/VoucherCategory/SortVoucherBrandBasedOnCategory";
import UpdateRequestCompany from "./Company/UpdateRequestCompany";
import UpdateMyRequestCompany from "./Company/UpdateMyRequestCompany";

import {useDropzone} from 'react-dropzone';
import StoreItemClone from "./Store/Items/StoreItemClone";

const Dashboard = (props) => {


    useDropzone();
    
    let location = useLocation();
    let pathName = location.pathname;
    pathName = pathName.split('/');
    let secondIndex = pathName[2];


    const [profile, setProfile] = useState([]);
    const [QRInformation, setQRInformation] = useState({});


    //force update starts 
    const [counter, setCounter] = useState({ viewProfile: 0, balances: 0 });
    const forceUpdate = (param) => {
        setCounter((previousState) => {
            return { ...previousState, [param]: previousState[param] + 1 };
        });
    }
    //force update ends


    // Selected Company Profile 
    useEffect(() => {
        if (JSON.parse(localStorage.getItem('CompanyId')) <= 0) {
            return;
        }

        PostLoginGetApi("profile", "", 2).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setQRInformation(responseData["data"]);
                }
            }

        }).catch((err) => {
            console.log(err);
            toast.error("A problem occur.");
        });

    }, [counter]);


    // User Profile
    useEffect(() => {
        PostLoginGetApi("user/profile").then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setProfile(responseData["data"]);
                    window.localStorage.setItem('UserAccess', responseData["data"]?.permissions ?? []);
                }
            }

        }).catch((err) => {
            toast.error("A problem occur. Please try again.");
        });

    }, [counter]);



    return (
        <>
            <ToastContainer></ToastContainer>
            <Routes>
                <Route path="/dashboard/logout" element={<Logout />} />
            </Routes>

            <RootContext.Provider value={{ forceUpdate: forceUpdate }}>


                {
                    <IncompleteProfileStepsContextProvider>
                        <UserBasicInfoContext.Provider value={profile}>
                            <UserBasicInfoQRContext.Provider value={QRInformation}>

                                {/* Company List */}
                                <Routes>
                                    <Route path="/dashboard/select-company" element={<SelectCompany />} ></Route>
                                </Routes>


                                {/* Stores Popups */}
                                <Routes>
                                    <Route exact path="/dashboard/store/add-item" element={<StoreItemAdd />}></Route>
                                    <Route path="/dashboard/store/clone-item/:id" element={<StoreItemClone />} ></Route>
                                    <Route path="/dashboard/store/edit-item/:id" element={<StoreEditItem />} ></Route>
                                    <Route path="/dashboard/store/assign-more-img/:id" element={<AssignItemImage />} ></Route>
                                    <Route path="/dashboard/store/items-details" element={<StoreItemsDetails />} ></Route>

                                    
                                    <Route path="/dashboard/store/clone-item/:id" element={<StoreItemClone />} ></Route>

                                    <Route exact path="/dashboard/store/create-category" element={<StoreCreateCategory />}></Route>
                                    <Route exact path="/dashboard/store/edit-category" element={<StoreEditCategory />}></Route>

                                    <Route path="/dashboard/store/discount/create" element={<StoreCreateDiscount />} ></Route>
                                    <Route path="/dashboard/store/discount/edit" element={<StoreEditDiscount />} ></Route>

                                    <Route path="/dashboard/store/pickup/upload-pickup" element={<UploadInvoice />} ></Route>
                                    <Route path="/dashboard/store/item/update-quantity" element={<UpdateQuantity />} ></Route>
                                </Routes>


                                {/* Order */}
                                <Routes>
                                    <Route path="/dashboard/orders/order-invoice/:id" element={<OrderInvoice />} ></Route>
                                </Routes>

                                {/* User/Vendor/Manager/other creation */}
                                <Routes>
                                    <Route path="/dashboard/user/create-user" element={<UserCreation />}></Route>
                                    <Route path="/dashboard/user/edit-user" element={<UpdateUser />}></Route>
                                </Routes>

                                {/* Business Category */}
                                <Routes>
                                    <Route path="/dashboard/category/create-business-category" element={<CreateBusinessCategory />}></Route>
                                    <Route path="/dashboard/category/edit-business-category" element={<UpdateBusinessCategory />}></Route>
                                </Routes>

                                {/* Voucher Category */}
                                <Routes>
                                    <Route path="/dashboard/category/create-voucher-category" element={<CreateVoucherCategory />} ></Route>
                                    <Route path="/dashboard/category/edit-voucher-category" element={<EditVoucherCategory />} ></Route>
                                </Routes>

                                {/* Create New Role */}
                                <Routes>
                                    <Route path="/dashboard/role/create" element={<AddRole />}></Route>
                                    <Route path="/dashboard/role/edit/:id" element={<EditRole />}></Route>
                                </Routes>

                                {/* Create Company */}
                                <Routes>
                                    <Route path="/dashboard/company/create-company" element={<CreateCompany />}></Route>
                                    <Route path="/dashboard/company/edit-company" element={<UpdateCompany />}></Route>
                                    <Route path="/dashboard/company/active-company" element={<ActiveCompanyFromRequest />}></Route>
                                    <Route path="/dashboard/company/edit-req-company" element={<UpdateRequestCompany />}></Route>
                                    <Route path="/dashboard/edit-myreq-company" element={<UpdateMyRequestCompany />}></Route>
                                </Routes>

                                {/* Voucher */}
                                <Routes>
                                    <Route path="/dashboard/voucher/create-brand" element={<CreateBrand />} ></Route>
                                    <Route path="/dashboard/voucher/edit-brand" element={<EditBrand />} ></Route>
                                    <Route path="/dashboard/voucher/create-offer" element={<CreateOffer />} ></Route>
                                    <Route path="/dashboard/voucher/edit-offer" element={<EditOffer />} ></Route>
                                </Routes>


                                {/* Voucher */}
                                <Routes>
                                    <Route path="/dashboard/mou/create" element={<CreateMou />} ></Route>
                                    <Route path="/dashboard/mou/edit" element={<EditMou />} ></Route>
                                </Routes>






                                <div className="flex w-screen min-h-full h-screen fixed bg-white">


                                    <Sidebar name={secondIndex} />

                                    <div className="h-screen w-screen">

                                        {/* Top Navbar */}
                                        <Navbar name={secondIndex} />



                                        <Routes>

                                            <Route path="/dashboard/home" element={<Home />} />

                                            {/* Store */}
                                            <Route path="/dashboard/store" element={<Store></Store>}></Route>


                                            {/* Settlement */}
                                            <Route path="/dashboard/settlement" element={<Settlement></Settlement>}></Route>



                                            {/* Reports */}
                                            <Route path="/dashboard/reports" element={<Reports />} />


                                            <Route path="/dashboard/account-settings" element={<AccountSettings />} />

                                            <Route path="/dashboard/voucher" element={<Voucher />} />


                                            {/* Orders */}
                                            <Route path="/dashboard/orders" element={<Orders />} />


                                            {/* User */}
                                            <Route path="/dashboard/user" element={<UserList />}></Route>



                                            {/* Company */}
                                            <Route path="/dashboard/company" element={<Company />}></Route>
                                            <Route path="/dashboard/company-details/:id" element={<CompanyDetails />}></Route>

                                            {/* Category */}
                                            <Route path="/dashboard/category" element={<Category />}></Route>

                                            {/* sort voucher brands */}
                                            <Route path="/dashboard/voucher/sort-brand" element={<SortVoucherBrandBasedOnCategory />}></Route>

                                            
                                            {/* Bank & Branch */}
                                            <Route path="/dashboard/bank-branch" element={<BankBranch />}></Route>

                                            {/* Business Category */}
                                            {/* <Route path="/dashboard/business-category" element={<BusinessCategoryList />}></Route> */}

                                            {/* Voucher Category */}
                                            {/* <Route path="/dashboard/business-category" element={<VoucherCategory />}></Route> */}

                                            {/* Role */}
                                            <Route path="/dashboard/role" element={<RoleList />}></Route>

                                            {/* Permission */}
                                            <Route path="/dashboard/permission" element={<PermissionList />}></Route>

                                            {/* Role Access */}
                                            <Route path="/dashboard/role/access/:id" element={<ViewAccess />}></Route>
                                            <Route path="/dashboard/role/access-edit/:id" element={<EditAccess />}></Route>



                                            {/* Access Denied */}
                                            <Route path="/dashboard/access-denied" element={<AccessDenied title="Access Denied" message="You don't have permission to view this page" />}></Route>


                                            {/* Reports */}
                                            {/* <Route path="/dashboard/reports" element={<Reports />}></Route> */}


                                        </Routes>


                                    </div>
                                </div>
                            </UserBasicInfoQRContext.Provider>

                        </UserBasicInfoContext.Provider>
                    </IncompleteProfileStepsContextProvider>
                }

            </RootContext.Provider>

        </>
    )
}


export default Dashboard;
